<template>
  <div class="alfapaymentstatus-component">
    <div class="payment-status-window">
      <div class="payment-status-window__message">
        {{ resultMessage }}
      </div>

      <div class="payment-status-window__loading" v-if="timer">
        <i class="fa fa-ellipsis fa-beat payment-status-window__loading-icon"></i>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';

export default {

  name: 'AlfaPaymentStatus',

  props: {
    orderId: {
      type: String,
      default: null
    },
    redirectTo: {
      type: String,
      default: null
    }
  },

  components: {

  },

  watch: {
    tryCounter(tryCount) {
      if(tryCount === 0) {
        this.stopTimer()
      }
    }
  },

  data() {
    return {
      alfaPayment: null,
      tryCounter: 15,
      timer: null,
      resultMessage: 'Пожалуйста, подождите. Проверяем ответ из банка.'
    }
  },

  mounted() {
    if (this.orderId) {
      this.startTimer()
    }
  },

  methods: {
    getStatus() {
      axios.get(`/alfa/api/payment-status/${this.orderId}/`).then(
        response => {
          this.alfaPayment = response.data
          if (this.alfaPayment && this.alfaPayment.is_completed) {
            this.resultMessage = this.alfaPayment.get_order_status_display
            clearTimeout(this.timer)
            
            if (this.alfaPayment.order_status === 2 && this.redirectTo) {
              setTimeout(() => {
                window.location = this.redirectTo
              }, 800)
            }
            else {
              this.timer = null
            }

          }
        }
      )
    },

    startTimer() {
      this.timer = setInterval(() => {
        this.tryCounter--
        this.getStatus()
      }, 1000)
    },

    stopTimer() {
      clearTimeout(this.timer)
      this.timer = null
      this.resultMessage = 'Не удалось получить статус заказа. Попробуйте обновить страницу.'
    }
  },

}
</script>


<style lang="scss">
  
</style>
